export default
{
    namespaced: true,
    
    state:
    {
        cityWeather: { temperature: 0, description: 'clear' }
    },
    mutations:
    {
        setCityWeather (state, weather) 
        {
            state.cityWeather = weather
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/weather.js